var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "39F3918F-5E9B-4964-A1EC-03EAFAFCAD46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_Q4_GVT-experience",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GVT_AUTH_Scheduling_viewmoretopics_desktop",
    transform: "translate(-784.000000, -1124.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Text-/-Building-Blocks-/-+-Icon-/-on-dark",
    transform: "translate(613.500000, 1101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Text-/-Blue-/-With-Icon-/-Default",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(147.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,0 C15.7761424,0 16,0.223857625 16,0.5 C16,0.745459889 15.8231248,0.94960837 15.5898756,0.991944331 L15.5,1 L0.5,1 C0.223857625,1 0,0.776142375 0,0.5 C0,0.254540111 0.176875161,0.0503916296 0.410124368,0.00805566941 L0.5,0 L15.5,0 Z",
    id: "Icon-Fill-Color-"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.198bee4f99868278bf081b996aa7ae4c.svg";
export { ForwardRef as ReactComponent };